import { compareDesc } from 'date-fns';

export function isDateBetween(startDate: Date, endDate: Date) {
  const compareStart = compareDesc(startDate, new Date());
  const compareEnd = compareDesc(new Date(), endDate);
  return compareStart + compareEnd === 2;
}
